import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { TIMETABLE_EXCEPTION } from 'SharedDir/backend/endpoints/timetable-exception';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';
import { TimetableException } from 'SharedDir/declarations/timetable-exceptions';

export default class TimetableExceptionsApiClass {
  public static async list<Extra extends object>(
    params: PaginationParams<Extra>
  ): Promise<TimetableException[]> {
    const responseData: TimetableException[] = await http({
      ...TIMETABLE_EXCEPTION.LIST,
      params
    })
      .then((r): TimetableException[] => r.data.data);

    return responseData;
  }

  public static async create(data: TimetableException): Promise<TimetableException> {
    const responseData: TimetableException = await http({
      ...TIMETABLE_EXCEPTION.STORE,
      data,
    })
      .then((r): TimetableException => r.data);

    return responseData;
  }

  public static async destroy(id: number): Promise<TimetableException> {
    const responseData: TimetableException = await http({
      ...TIMETABLE_EXCEPTION.DELETE(id),
    })
      .then((r): TimetableException => r.data);

    return responseData;
  }
}
